import { ITreatmentClassification, ThemeClassification } from 'types';

import { Stack, Typography } from '@mui/material';

type Props = {
  classification: ITreatmentClassification;
  title: string;
};

export const CardSymptom: React.FC<Props> = ({ title, classification }) => {
  if (!ThemeClassification[classification]) {
    return null;
  }

  const { color } = ThemeClassification[classification];

  return (
    <Stack
      direction="row"
      borderRadius={1}
      justifyContent="center"
      alignItems="center"
      sx={{
        padding: '10px',
        minWidth: '100px',
        height: '46px',
        color: 'white',
        background: color,
        border: '1px solid color',
      }}
    >
      <Typography
        px={4}
        fontSize={14}
        fontWeight={400}
        sx={{ textTransform: 'uppercase' }}
      >
        {title}
      </Typography>
    </Stack>
  );
};

